import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Store } from 'app/views/campaign-3/models/campaign-3.model';
import { AreaGeo, Group, Insegna } from 'app/views/campaign-3/models/campaign-3-touchpoint.model';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { MessageService, MultiSelect } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-campaign-3-search-stores',
  templateUrl: './campaign-3-search-stores.component.html',
  styleUrls: ['./campaign-3-search-stores.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3SearchStoresComponent implements OnInit {
  
  @Input() storesList: Array<Campaign3Store> = [];
  @Input() areeList: Array<AreaGeo> = [];
  @Input() groupList: Array<Group> = [];
  @Input() readOnly: boolean = false;
  @Input() insegneList: Array<Insegna> = [];
  @Output() storesListSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() storesListCancel: EventEmitter<boolean> = new EventEmitter<boolean>();

  
  @ViewChild('storesListTable') storesListTableComponent: Campaign3KontableComponent;
  @ViewChild('gruppoFilterMultiselect') gruppoFilterMultiselectComponent: MultiSelect;

  listStoresSelected: Array<Campaign3Store> = [];
  paginationType: number = Campaign3KontableComponent.NoPagination;
  customFilter: number = Campaign3KontableComponent.CustomFilter;

  show = {
    table: false
  }

  fieldModel = {
    groupName: null
  }

  filterModel = {
    insegna: [],
    gruppo: [],
    area: []
  }

  constructor(private srvCampaign: Campaign3Service,private srvMessage: MessageService,    private translate: TranslateService    ) {}
  ngOnInit() {
    if(this.storesList){

      for(let store of this.storesList){
        if(store.rowSelected == true){
          this.listStoresSelected.push(Object.assign({},store));
        }
      }
      this.show.table = true;
    }
  }
  onStoresSelected(product: any){
    if(!this.readOnly){
      let indexInSelected = this.listStoresSelected.findIndex(x=>x.id == product.id);
      if(!product.rowSelected){
        if(indexInSelected>-1) this.listStoresSelected.splice(indexInSelected,1);
      }
      else if(product.rowSelected){
        if(indexInSelected==-1) this.listStoresSelected.push(product);
      }
    }
  }
  onClickRemoveSelected(index:number){
    let id = this.listStoresSelected[index].id;
    this.listStoresSelected.splice(index,1);
    this.storesList.find(x=>x.id == id)["rowSelected"]=false;
  }
  onClickAggiungiStores(){
    if(this.listStoresSelected && this.listStoresSelected.length){
      this.storesListSelected.emit(this.listStoresSelected);
    }
    else{
      this.storesListSelected.emit(null);
    }
  }
  onClickAnnullaStores(){
    this.storesListCancel.emit(true);
  }
  onChangeFilters(){
    this.refreshTable();
  }
  onClickSaveGroup(){

    if(this.fieldModel.groupName && this.listStoresSelected && this.listStoresSelected.length>0) {
      const groupData = {
        'name': this.fieldModel.groupName,
        'code': Date.now()
      };
      var self = this;
      this.srvCampaign.createGroup(groupData).subscribe(res => {
        if(res && res.id>0){
          let newGroup = new Group();
          newGroup.id = res.id;
          newGroup.name = this.fieldModel.groupName;
          newGroup.code = res.code;
          let arrayStoresId = [];
          for(let store of self.listStoresSelected){
            arrayStoresId.push(store.id);
          }
          if(arrayStoresId.length>0){
            self.srvCampaign.setStoresInGroup(res.id,arrayStoresId).subscribe(res2=>{
              var self2=self;
              if(res2){
                self2.groupList.unshift(newGroup);
                self2.gruppoFilterMultiselectComponent.options.unshift({label: newGroup.name, value: newGroup});
                self2.srvMessage.add({
                  severity: 'success',
                  summary: this.translate.instant('common.success'),
                  detail: this.translate.instant('campaign.group_stores_saved_successfully')
                });
                              }
              else{
                self2.srvMessage.add({
                  severity: 'error',
                  summary: this.translate.instant('common.error'),
                  detail: this.translate.instant('campaign.error_saving_group_stores')
                });
                              }
            });
          }
        }
        else{
          self.srvMessage.add({
            severity: 'error',
            summary: this.translate.instant('common.error'),
            detail: this.translate.instant('campaign.error_saving_group_stores')
          });
                  }
      });
    }
  
  }
  refreshTable(){
    
    var filterObj = {
      area: [],
      gruppoCode: [],
      insegnaCode: []
    }
    for(let area of this.filterModel.area){
      if(area && area.codice){
        filterObj.area.push(area.codice);
      }
    }
    for(let gruppo of this.filterModel.gruppo){
      if(gruppo && gruppo.code){
        filterObj.gruppoCode.push(gruppo.code);
      }
    }
    for(let insegna of this.filterModel.insegna){
      if(insegna && insegna.codice){
        filterObj.insegnaCode.push(insegna.codice);
      }
    }

    this.srvCampaign.getStoresFromCampaigns(filterObj).subscribe(res=>{
      if(res){
        this.storesList = Object.assign([],res);

        for(let store of this.listStoresSelected){
          let storeFound = this.storesList.find(x=>x.id == store.id);
          if(storeFound){
            storeFound.rowSelected = store.rowSelected;
          }
        }
      }
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-stores/campaign-3-search-stores.component.ts